


function CanvasDataURL(path, obj) {
  var p =  new Promise((r) => {
      var img = new Image();
      img.src = path;
      img.setAttribute("crossOrigin",'Anonymous')
      img.onload = function() {
        var that = this;
        // 默认按比例压缩
        var w, h;
        if(w > h) {
            w = 460;
            h = that.height / that.width * 460;
        } else {
            h = 460;
            w = that.width / that.height * 460;
        }
        var quality = 0.9; // 默认图片质量为0.7
        //生成canvas
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        // 创建属性节点
        var anw = document.createAttribute("width");
        anw.nodeValue = w;
        var anh = document.createAttribute("height");
        anh.nodeValue = h;
        canvas.setAttributeNode(anw);
        canvas.setAttributeNode(anh);
        ctx.drawImage(that, 0, 0, w, h);
        // 图像质量
        if(obj.quality && obj.quality <= 1 && obj.quality > 0) {
            quality = obj.quality;
        }
        // quality值越小，所绘制出的图像越模糊
        var base64 = canvas.toDataURL('image/jpeg', quality);
        // 回调函数返回base64的值
        r(base64);
    }
  })
  return p
}


export default {CanvasDataURL}